import React from "react";

export default function NotificationContainer({ notifications, onRemove }) {
  return (
    <div className="fixed top-4 right-4 space-y-2 z-50">
      {notifications.map((n) => (
        <div
          key={n.id}
          className={`max-w-sm p-4 rounded shadow-lg text-white
            ${n.type === "success" ? "bg-green-500" : ""}
            ${n.type === "error" ? "bg-red-500" : ""}
            ${n.type === "info" ? "bg-blue-500" : ""}
            ${n.type === "warn" ? "bg-yellow-500 text-black" : ""}`}
        >
          <div className="font-bold">{n.title}</div>
          <div>{n.message}</div>
          <button
            className="absolute top-2 right-2 text-sm"
            onClick={() => onRemove(n.id)}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
